import { render, staticRenderFns } from "./SidebarNewPackage.vue?vue&type=template&id=00bb4a0e"
import script from "./SidebarNewPackage.vue?vue&type=script&lang=js"
export * from "./SidebarNewPackage.vue?vue&type=script&lang=js"
import style0 from "./SidebarNewPackage.vue?vue&type=style&index=0&id=00bb4a0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports